import { c as _c } from "react/compiler-runtime";
// «Получатель» (список сохранённых получателей) и «Добавить получателя»
// (Имя / Фамилия / Телефон) — кадры 4 и 5 макета «5.1 Оформление заказа-2».
import { Edit20Icon, TrashIcon } from "@/components/icons";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, type BuyerRecipient } from "@/api";
import { CheckoutModal, IconAction, ListRow, ModalButton, ModalField, phoneLabel, ruPhoneE164, ruPhoneMask, ruPhoneTyped } from "./ui";
export const recipientLabel = (r: Pick<BuyerRecipient, "firstName" | "lastName">): string => [r.firstName, r.lastName].filter(Boolean).join(" ");
export function RecipientListModal(t0) {
  const $ = _c(15);
  const {
    open,
    onOpenChange,
    recipients,
    selectedId,
    onSelect,
    onAdd,
    onEdit,
    onChanged
  } = t0;
  let t1;
  if ($[0] !== onChanged) {
    t1 = async r => {
      ;
      try {
        await api.buyer.deleteRecipient(r.id);
        onChanged();
      } catch (t2) {
        const e = t2;
        toast.error(e instanceof Error ? e.message : "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044F");
      }
    };
    $[0] = onChanged;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const remove = t1;
  let t2;
  if ($[2] !== onEdit || $[3] !== onSelect || $[4] !== recipients || $[5] !== remove || $[6] !== selectedId) {
    t2 = recipients.length > 0 && <div className="mb-5 flex flex-col rounded-[12px] bg-[#F8F8F8]">{recipients.map(r_0 => <ListRow key={r_0.id} selected={r_0.id === selectedId} onSelect={() => onSelect(r_0)} actions={<><IconAction label={"\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044F"} onClick={() => onEdit(r_0)}><Edit20Icon size={20} /></IconAction><IconAction label={"\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044F"} onClick={() => void remove(r_0)}><TrashIcon size={20} /></IconAction></>}>{r_0.firstName}, {phoneLabel(r_0.phone)}</ListRow>)}</div>;
    $[2] = onEdit;
    $[3] = onSelect;
    $[4] = recipients;
    $[5] = remove;
    $[6] = selectedId;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== onAdd) {
    t3 = <ModalButton onClick={onAdd} data-testid="recipient-add">Добавить получателя</ModalButton>;
    $[8] = onAdd;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== onOpenChange || $[11] !== open || $[12] !== t2 || $[13] !== t3) {
    t4 = <CheckoutModal open={open} onOpenChange={onOpenChange} title={"\u041F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044C"} testId="recipient-modal">{t2}{t3}</CheckoutModal>;
    $[10] = onOpenChange;
    $[11] = open;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}
export function RecipientFormModal({
  open,
  onOpenChange,
  recipient,
  defaults,
  persist = true,
  onSaved
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  recipient: BuyerRecipient | null;
  defaults?: {
    firstName: string;
    lastName: string;
    phone: string;
  };
  // Гость: получатель живёт только в оформлении, на шлюз не сохраняется.
  persist?: boolean;
  onSaved: (recipient: BuyerRecipient) => void;
}) {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    if (!open) return;
    const src = recipient ?? defaults;
    setFirstName(src?.firstName ?? "");
    setLastName(src?.lastName ?? "");
    setPhone(src?.phone ? ruPhoneMask(src.phone) : "");
    setError(null);
    // biome-ignore lint/correctness/useExhaustiveDependencies: seed once per opening
  }, [open, recipient]);
  const e164 = ruPhoneE164(phone);
  const canSave = firstName.trim().length > 0 && Boolean(e164);
  const save = async () => {
    if (!canSave) {
      setError(e164 ? null : "Проверьте номер телефона");
      return;
    }
    setBusy(true);
    try {
      const input = {
        firstName: firstName.trim(),
        lastName: lastName.trim(),
        phone: e164
      };
      if (!persist) {
        const now = new Date().toISOString();
        onSaved({
          id: "",
          ...input,
          isDefault: false,
          createdAt: now,
          updatedAt: now
        });
        return;
      }
      const saved = recipient ? await api.buyer.updateRecipient(recipient.id, {
        ...input,
        isDefault: recipient.isDefault
      }) : await api.buyer.createRecipient(input);
      onSaved(saved);
    } catch (e) {
      toast.error(e instanceof Error ? e.message : "Не удалось сохранить получателя");
    } finally {
      setBusy(false);
    }
  };
  return <CheckoutModal open={open} onOpenChange={onOpenChange} title={recipient ? "Изменить получателя" : "Добавить получателя"} testId="recipient-form">
			<div className="flex flex-col gap-3">
				<ModalField label="Имя" value={firstName} onChange={setFirstName} autoFocus testId="recipient-first-name" />
				<ModalField label="Фамилия" value={lastName} onChange={setLastName} testId="recipient-last-name" />
				<ModalField label="Телефон" value={phone} inputMode="tel" placeholder="+7(900)000-00-00" error={error} testId="recipient-phone" onChange={v => {
        setError(null);
        setPhone(ruPhoneTyped(v, phone));
      }} />
			</div>
			<ModalButton className="mt-5" disabled={busy} onClick={() => void save()} data-testid="recipient-save">
				Сохранить
			</ModalButton>
		</CheckoutModal>;
}